import Text from '@ingka/text';
import SSRIcon from '@ingka/ssr-icon';
import LinkOutIcon from '@ingka/ssr-icon/paths/link-out';
import { ArrowBigDown } from 'lucide-react';
import { Alert, AlertTitle } from '@/components/ui/alert';

import { renderPhraseString } from './util';

type BannerMiniPreviewProps = {
  showInPages?: string[];
  headerVisible: boolean;
  phraseStrings: { [key: string]: string };
  className?: string;
};

export const BannerMiniLinkPreview = (props: BannerMiniPreviewProps) => {
  const { showInPages, headerVisible, phraseStrings } = props;
  const showInPagesActive = showInPages && showInPages.includes('pip');

  return (
    <>
      {showInPagesActive && (
        <div
          id='plann-mini-fragment-link'
          className={`w-1/2 ${props.className}`}
        >
          {headerVisible && (
            <Alert className='mb-4 border-slate-800 bg-slate-800  text-white'>
              <ArrowBigDown className='h-4 w-4' />
              <AlertTitle className='font-bold'>
                PIP buy module banner
              </AlertTitle>
            </Alert>
          )}
          <a
            className='plann-mini-fragment-link flex items-center justify-between w-full py-4 gap-4 box-border border-t border-neutral-300 hover:no-underline group bg-white mb-4'
            target='_blank'
          >
            <span className='plann-mini-fragment-link__info-wrapper group-hover:block'>
              <Text
                className='plann-mini-fragment-link__title group-hover:underline  font-bold text-black'
                tagName='h2'
                color='colourTextAndIcon1'
              >
                {renderPhraseString('small-title', phraseStrings)}
              </Text>
              <Text
                className='plann-mini-fragment-link__description group-hover:no-underline text-sm text-black'
                tagName='p'
              >
                {renderPhraseString('small-description', phraseStrings)}
              </Text>
            </span>
            <span className='plann-mini-fragment-link__icon-button group-hover:block fill-black'>
              <SSRIcon paths={LinkOutIcon} />
            </span>
          </a>
        </div>
      )}
    </>
  );
};
